export enum ChargingStationDetailsSteps {
  placement = 'placement',
  accessBadge = 'access-badge',
}
